import React from 'react'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import SingleArticle from '../partials/SingleArticle'
import Pagination from '../../partials/Pagination'

import Container from '../partials/Container'

import strings from '../../../utils/strings'

@inject('Auth', 'User', 'Blog')
@observer
export class News extends React.Component {
  constructor (props) {
    super(props)
    this.searchPosts(props)
  }

  componentWillReceiveProps (nextProps) {
    return this.searchPosts(nextProps)
  }

  searchPosts (props) {
    const _findPosts = () => {
      return setTimeout(() => {
        if (props.Auth.token.pending || props.User.me.pending) {
          return _findPosts()
        }

        const query = strings.parseQueryParams(props.location.search)
        props.Blog.setPagination({ page: +query.page })
        props.Blog.searchPosts({})
      }, 100)
    }

    _findPosts()
  }

  render () {
    return (
      <Container {...this.props}>
        <Row>
          <Col>
            {this.props.Blog.posts
              .slice()
              .map((article, index) => (
                <SingleArticle key={index} {...article} short />
              ))}
            <Pagination
              baseUrl={`/dashboard/news`}
              currentPage={this.props.Blog.pagination.page}
              maxPage={this.props.Blog.pagination.max}
              queryString
            />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default News



// WEBPACK FOOTER //
// ./src/components/News/Main/index.js